import { useSession } from 'next-auth/client';
import { useEffect, useRef } from 'react';
import { clearOpenAIUser, identifyOpenAIUser } from './identity';

export const OpenAIIdentity = () => {
  const [session, loading] = useSession();
  const lastUserId = useRef<string | null>(null);

  useEffect(() => {
    if (loading) return;

    const user = session?.user;
    const userId =
      user?.userId !== undefined && user.userId !== null
        ? String(user.userId)
        : null;

    if (!userId) {
      if (lastUserId.current !== null) {
        clearOpenAIUser();
        lastUserId.current = null;
      }

      return;
    }

    if (lastUserId.current && lastUserId.current !== userId) {
      clearOpenAIUser();
    }
    lastUserId.current = userId;

    void identifyOpenAIUser({
      email: user?.email,
      phone: user?.phoneNumber,
      externalId: user?.userId,
      firstName: user?.firstName,
      lastName: user?.lastName,
    });
  }, [loading, session]);

  return null;
};
